var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_vm._l((_vm.data),function(item,i){return _c('div',[(item.strong == true)?_c('div',{staticClass:"margin-top"},[_c('strong',[_vm._v(" "+_vm._s(item.title))])]):_c('div',{staticClass:"margin-top"},[_vm._v(_vm._s(item.title))])])}),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._v("北京技能码科技有限公司")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c0a9319","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/JnmPrivacyPolicy.vue
// module id = null
// module chunks = 